import React from 'react';
import Head from 'next/head';
import type { WPublicWeddingView } from '@zola/svc-web-api-ts-client';

type PublicV2MetadataProps = {
  wedding: WPublicWeddingView;
};

const PublicV2Metadata = ({ wedding }: PublicV2MetadataProps): JSX.Element => (
  <Head>
    <title>{`${wedding.owner_first_name} ${wedding.owner_last_name} and ${wedding.partner_first_name} ${wedding.partner_last_name}'s Wedding Website`}</title>
    <meta
      name="description"
      content={`The wedding website of ${wedding.owner_first_name} ${wedding.owner_last_name} and ${wedding.partner_first_name} ${wedding.partner_last_name}`}
    />
    <meta
      name="keywords"
      content={`wedding website, ${wedding.owner_first_name} ${wedding.owner_last_name}, ${wedding.partner_first_name} ${wedding.partner_last_name}, ${wedding.owner_first_name} and ${wedding.partner_first_name}`}
    />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  </Head>
);

export default PublicV2Metadata;
